import React, { useEffect, useState } from 'react'
import { useOrderStore } from 'src/hooks/order'
import OrderReportCard from './OrderReportCard'

const ManageOrderReport = (props) => {
    const statusOptions = props.statusOptions || [];
    const includeOrdersFromOptions = props.includeOrdersFromOptions || [];
    const reportFrequencyOptions = props.reportFrequencyOptions || [];
    const [orderReports, setOrderReports] = useState([]);

    const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [orderReportToDelete, setOrderReportToDelete] = useState(null);
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [{}, {}, { get_order_reports, delete_order_report }] = useOrderStore();

    const getOrderReports = async () => {
        setLoading(true);

        try {
            const response = await get_order_reports();
            setOrderReports(response?.data?.data || [])
        } catch (error) {

        }

        setLoading(false);
    }

    const deleteReportHandler = (reportId) => {
        const orderReport = orderReports.find(report => report.scheduledOrderReportId === reportId);
        setOrderReportToDelete(orderReport)
        setShowDeleteConfirmation(true)
    }

    const finalizeDeletion = async () => {
        try {
            setSubmitting(true);
            await delete_order_report(orderReportToDelete.scheduledOrderReportId);
        } catch(error) {

        }

        setOrderReports(orderReports.filter(report => report.scheduledOrderReportId !== orderReportToDelete.scheduledOrderReportId));
        setShowDeleteSuccess(true);
        setSubmitting(false);
        setShowDeleteConfirmation(false);
    }

    useEffect(() => {
        getOrderReports();
    }, [])

    return (
        <div id="order-report-modal">
            <div className="bs5 modal-header border-0">
                <h3 className="modal-title" id="exampleModalLabel">Manage Scheduled Reports</h3>
                <button
                    type="button"
                    className="close py-3"
                    data-dismiss="modal"
                    onClick={() => props.closeModal()}
                >×</button>
            </div>

            { !showDeleteConfirmation && !showDeleteSuccess && <hr className="mt-0 mb-0" /> }
            <div className="modal-body allow-overflow manage-reports-wrapper">
                {
                    loading ? (
                        <div>
                            <p className="text-center">Loading scheduled reports...</p>
                        </div>
                    ) : (
                        <div>

                            {
                                showDeleteConfirmation ? (
                                    <>
                                        <p className="confirmation-message text-start">
                                            <i className="fa fa-exclamation-triangle text-yellow fa-lg" aria-hidden="true"></i>
                                            <strong>Are you sure you want to delete this report?</strong>
                                        </p>
                                        <OrderReportCard
                                            key={`selected-order-report-card-${orderReportToDelete.scheduledOrderReportId}-${orderReportToDelete.reportName}-${orderReportToDelete.frequencyDays}-${orderReportToDelete.includeOrdersFromDays}`}
                                            reportId={orderReportToDelete.scheduledOrderReportId}
                                            reportName={orderReportToDelete.reportName}
                                            frequencyDays={orderReportToDelete.frequencyDays}
                                            includeOrdersFromDays={orderReportToDelete.includeOrdersFromDays}
                                            orderStatuses={orderReportToDelete.orderStatuses}
                                            reportFrequencyOptions={reportFrequencyOptions}
                                            includeOrdersFromOptions={includeOrdersFromOptions}
                                            statusOptions={statusOptions}
                                            deleteReportHandler={deleteReportHandler}
                                        />
                                    </>
                                ) : (
                                    <>
                                        {
                                            showDeleteSuccess ? (
                                                <>
                                                    <div className='d-flex align-items-center gap-2'>
                                                        <div className='success-check-circle small'></div>
                                                        <h4  className='m-0'><strong>Order Report Successfully Deleted.</strong></h4>
                                                    </div>

                                                    <p className="mt-3" style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                                        You will no longer receive "{orderReportToDelete.reportName}"
                                                    </p>
                                                </>
                                            ) : (
                                                <>
                                                    {
                                                        orderReports.length === 0 ? (
                                                            <p className="text-center">No Scheduled Reports.</p>
                                                        ) : (
                                                            <>
                                                                {

                                                                    orderReports.map((item) =>
                                                                        <OrderReportCard
                                                                            key={`order-report-card-${item.scheduledOrderReportId}-${item.reportName}-${item.frequencyDays}-${item.includeOrdersFromDays}`}
                                                                            reportId={item.scheduledOrderReportId}
                                                                            reportName={item.reportName}
                                                                            frequencyDays={item.frequencyDays}
                                                                            includeOrdersFromDays={item.includeOrdersFromDays}
                                                                            orderStatuses={item.orderStatuses}
                                                                            reportFrequencyOptions={reportFrequencyOptions}
                                                                            includeOrdersFromOptions={includeOrdersFromOptions}
                                                                            statusOptions={statusOptions}
                                                                            showDeleteAction={true}
                                                                            deleteReportHandler={deleteReportHandler}
                                                                        />
                                                                    )
                                                                }
                                                            </>
                                                        )
                                                    }
                                                </>
                                            )
                                        }
                                    </>
                                )
                            }
                        </div>
                    )
                }
            </div>
            <div className="modal-footer d-flex justify-content-center">
                {
                    showDeleteConfirmation ? (
                        <>
                            <button
                                type="button"
                                className="bs5 btn btn-secondary"
                                onClick={() => {
                                    setShowDeleteConfirmation(false);
                                    setOrderReportToDelete(null);
                                }}
                                disabled={submitting}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="bs5 btn btn-primary"
                                onClick={() => finalizeDeletion()}
                                disabled={submitting}
                            >
                                Confirm
                            </button>
                        </>
                    ) : (
                        <button
                            type="button"
                            className="bs5 btn btn-primary"
                            onClick={() => props.closeModal()}
                            disabled={false}
                        >
                            Close
                        </button>
                    )
                }

            </div>
        </div>
    )
}

export default ManageOrderReport
